import { render, staticRenderFns } from "./TwitterCompetition.vue?vue&type=template&id=3cac0bb7&scoped=true&"
import script from "./TwitterCompetition.vue?vue&type=script&lang=js&"
export * from "./TwitterCompetition.vue?vue&type=script&lang=js&"
import style0 from "./TwitterCompetition.vue?vue&type=style&index=0&id=3cac0bb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac0bb7",
  null
  
)

export default component.exports